'use strict';

/**
 *
 * @category   View
 * @module     base
 * @copyright  Copyright (c) 2025, COLIDO (http://www.colido.net)
 * @author     Augusto Campos-Leiva <augusto@campos-leiva.de>
 */

var ColidoLayoutView = require('base/Colido.LayoutView');

var template = require('modules/base/templates/layout/restriction-sell-modal.hbs');

var RestrictionModalView = ColidoLayoutView.extend({
    template: template,

    ui: {
        actionClose: '[data-action="close"]',
    },

    events: {
        'click @ui.actionClose': 'actionClose',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },
});

module.exports = RestrictionModalView;